module.exports = __webpack_public_path__ + "img/bithotel.65fde5eb.png";